const index = (): boolean => navigator.platform.toUpperCase().includes('MAC')

export default index
